import { Box, Chip, Stack, Typography, useTheme } from "@compass/core";
import { Logo } from "components";
import { Outlet } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

export const AuthLayout = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

  const renderSidePanel = () => {
    return (
      <Stack width="450px" bgcolor={theme.palette.background.paper} p={7}>
        {renderSidePanelHeader()}

        {renderSidePanelBody()}

        <Box display="flex" mt="auto" justifyContent="center">
          {renderCopyright()}
        </Box>
      </Stack>
    );
  };

  const renderSidePanelHeader = () => {
    return (
      <Stack direction="row" spacing="sm">
        <Box>
          <Logo width="62px" animate={true} />
        </Box>

        <Stack position="relative" justifyContent="center" spacing="xs" top="-2px">
          <Typography variant="h5">Compass</Typography>
          <Box>
            <Chip label="v2.0" color="primary" size="small" />
          </Box>
        </Stack>
      </Stack>
    );
  };

  const renderSidePanelBody = () => {
    return (
      <Stack mt={10} spacing="lg">
        <Typography variant="h4">CoBro Consulting Program Evaluation Systems & Services</Typography>

        <Typography variant="subtitle1" fontWeight={theme.typography.fontWeightLight}>
          We specialize in development and support of large scale data management systems and comprehensive program evaluation, including survey services, data
          analysis, and professional results reporting.
        </Typography>
      </Stack>
    );
  };

  const renderCopyright = () => {
    return (
      <Typography variant="caption">
        <>Copyright © 2006-{new Date().getFullYear()} Cobro Consulting. All Rights Reserved.</>
      </Typography>
    );
  };
  // const renderSidePanelLogo = () => {
  //   return (
  //     <Stack mt={10}>
  //       <Logo width="200px" animate={true} />
  //     </Stack>
  //   );
  // };

  return (
    <Stack
      width="100%"
      minHeight="100vh"
      direction="row"
      className="auth-layout"
      //sx={{ bgcolor: "black" }}
    >
      {isDesktop && renderSidePanel()}

      <Box position="relative" flexGrow={1}>
        <Outlet />
      </Box>
    </Stack>
  );
};
